import {WorkflowOption, WorkflowType} from "./types";
import {WORKFLOW_OPTIONS} from "./workflowConfig";

const ADMISSION = WorkflowType.ADMISSION;

/**
 * Legacy / alternate spellings → canonical template key.
 * Keeps lookups working if older uppercase enum values slip through.
 */
const WORKFLOW_TYPE_ALIASES: Record<string, WorkflowType> = {
  arbitration_agreement: WorkflowType.ARBITRATION,
};

const humanizeWorkflowType = (raw: string): string =>
  raw
    .split(/[-_]/)
    .filter(Boolean)
    .map(token => token.charAt(0).toUpperCase() + token.slice(1))
    .join(" ");

/** Canonical lowercase template key used for labels, colors, and routing. */
export const normalizeWorkflowType = (workflowType?: string): string => {
  if (!workflowType) return "";
  const normalized = workflowType.toLowerCase();
  return WORKFLOW_TYPE_ALIASES[normalized] ?? normalized;
};

const mapSingleWorkflowType = (rawType: string): WorkflowOption => {
  const normalized = normalizeWorkflowType(rawType);

  if (normalized in WORKFLOW_OPTIONS) {
    return WORKFLOW_OPTIONS[normalized as WorkflowType];
  }

  return {type: normalized, label: humanizeWorkflowType(normalized)};
};

/** Builds workflow options from template version workflowTypes (always includes admission). */
export const mapTemplateWorkflowTypesToOptions = (
  templateWorkflowTypes: ReadonlyArray<string>,
): ReadonlyArray<WorkflowOption> => {
  const types = new Set<string>([ADMISSION]);

  templateWorkflowTypes.forEach(type => {
    const normalized = normalizeWorkflowType(type);
    if (normalized && normalized !== ADMISSION) {
      types.add(normalized);
    }
  });

  return Array.from(types).map(mapSingleWorkflowType);
};

export const admissionOnlyWorkflowOption = (): WorkflowOption =>
  mapSingleWorkflowType(ADMISSION);

export {humanizeWorkflowType};
